// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors - Otyma Farma Refined */
  --primary-color: #12a046; /* Pharmacy Green */
  --primary-hover: #0e8339;
  --primary-light: rgba(18, 160, 70, 0.08);
  
  --secondary-color: #ffffff;
  --accent-color: #374151; /* Professional Slate Gray */
  
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  
  --text-primary: #111827;
  --text-secondary: #4b5563;
  --text-muted: #9ca3af;
  
  --background-light: #f9fafb;
  --background-white: #ffffff;
  --border-color: #f3f4f6;

  /* Typography - Modern Stack */
  --font-main: 'Inter', -apple-system, sans-serif;
  --font-title: 'Outfit', sans-serif;
  
  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;

  /* Shadows - Soft and Modern */
  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04);
  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
  --shadow-hover: 0 25px 50px -12px rgba(0, 0, 0, 0.1);

  /* Glassmorphism */
  --glass-bg: rgba(255, 255, 255, 0.8);
  --glass-border: rgba(255, 255, 255, 0.2);
  --glass-blur: blur(12px);

  /* Border Radius */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-xl: 24px;
}

* {
  box-sizing: border-box;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

body {
  margin: 0;
  font-family: var(--font-main);
  background: radial-gradient(circle at top right, #f9fafb, #f3f4f6);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

button {
  cursor: pointer;
  font-family: inherit;
}

/* Container Utility */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

/* Grid Utility */
.grid {
  display: grid;
  gap: var(--spacing-md);
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.grid-cols-5 {
  grid-template-columns: repeat(5, 1fr);
}

/* Responsive Breakpoints */
@media (min-width: 640px) {
  .grid-sm-2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .grid-md-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid-md-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid-lg-3 {
    grid-template-columns: repeat(3, 1fr);
  }

  .grid-lg-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1400px) {
  .grid-xl-5 {
    grid-template-columns: repeat(5, 1fr);
  }
}
/* Offer Sections */
.offer-section {
  margin-bottom: var(--spacing-xl);
  width: 100%;
}

.offer-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
  padding: 0 var(--spacing-md);
}

.offer-section-title {
  font-family: var(--font-title);
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.03em;
}

.offer-section-carousel-container {
  position: relative;
  width: 100%;
}

.offer-section-grid {
  display: flex;
  overflow-x: auto;
  gap: var(--spacing-lg);
  padding: 24px var(--spacing-md);
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}

.offer-section-grid::-webkit-scrollbar {
  display: none;
}

.offer-section-grid > * {
  flex: 0 0 280px;
  min-width: 280px;
}

@media (min-width: 1024px) {
  .offer-section-carousel-container {
     padding: 0 60px;
  }

  .offer-section-grid {
    padding: 32px 0;
  }

  .offer-section-grid > * {
    flex: 0 0 calc(20% - (var(--spacing-lg) * 4 / 5));
    min-width: 200px;
  }

  .offer-section-header {
    padding: 0 60px;
  }
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: var(--background-white);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
  visibility: hidden;
  opacity: 0;
}

.offer-section-carousel-container:hover .carousel-arrow {
  visibility: visible;
  opacity: 1;
}

.carousel-arrow:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-50%) scale(1.1);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-color);
}

.carousel-arrow-left {
  left: 20px;
}

.carousel-arrow-right {
  right: 20px;
}

.view-all-btn {
  color: var(--primary-color);
  background: var(--primary-light);
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-family: var(--font-title);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.view-all-btn:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-2px);
}

/* View All Card in Carousel */
.view-all-card:hover {
  border-color: var(--primary-color) !important;
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
  background-color: rgba(52, 131, 250, 0.02) !important;
}

.view-all-card:active {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .carousel-arrow {
    display: none; /* Mobile usa scroll natural */
  }
  
  .offer-section-carousel-container {
    padding: 0;
  }

  .offer-section-header {
    padding: 0 var(--spacing-md);
  }
}

/* Breadcrumbs Section */
.breadcrumb-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
}

.breadcrumb-item {
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 2px 4px;
  border-radius: 4px;
  text-decoration: none;
}

.breadcrumb-item:hover {
  color: var(--primary-color);
  background-color: rgba(52, 131, 250, 0.1);
}

.breadcrumb-separator {
  color: #ccc;
  font-size: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,wBAAwB,EAAE,mBAAmB;EAC7C,wBAAwB;EACxB,wCAAwC;;EAExC,0BAA0B;EAC1B,uBAAuB,EAAE,4BAA4B;;EAErD,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;;EAEvB,8BAA8B;EAC9B,+CAA+C;EAC/C,kCAAkC;;EAElC,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,8BAA8B;EAC9B,4CAA4C;EAC5C,mFAAmF;EACnF,uFAAuF;EACvF,oDAAoD;;EAEpD,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;;EAExB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kEAAkE;EAClE,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;KACG,eAAe;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iDAAiD;IACjD,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iDAAiD;EACjD,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa,EAAE,8BAA8B;EAC/C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[":root {\r\n  /* Colors - Otyma Farma Refined */\r\n  --primary-color: #12a046; /* Pharmacy Green */\r\n  --primary-hover: #0e8339;\r\n  --primary-light: rgba(18, 160, 70, 0.08);\r\n  \r\n  --secondary-color: #ffffff;\r\n  --accent-color: #374151; /* Professional Slate Gray */\r\n  \r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  \r\n  --text-primary: #111827;\r\n  --text-secondary: #4b5563;\r\n  --text-muted: #9ca3af;\r\n  \r\n  --background-light: #f9fafb;\r\n  --background-white: #ffffff;\r\n  --border-color: #f3f4f6;\r\n\r\n  /* Typography - Modern Stack */\r\n  --font-main: 'Inter', -apple-system, sans-serif;\r\n  --font-title: 'Outfit', sans-serif;\r\n  \r\n  /* Spacing */\r\n  --spacing-xs: 4px;\r\n  --spacing-sm: 8px;\r\n  --spacing-md: 16px;\r\n  --spacing-lg: 24px;\r\n  --spacing-xl: 32px;\r\n  --spacing-2xl: 48px;\r\n\r\n  /* Shadows - Soft and Modern */\r\n  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.04);\r\n  --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);\r\n  --shadow-hover: 0 25px 50px -12px rgba(0, 0, 0, 0.1);\r\n\r\n  /* Glassmorphism */\r\n  --glass-bg: rgba(255, 255, 255, 0.8);\r\n  --glass-border: rgba(255, 255, 255, 0.2);\r\n  --glass-blur: blur(12px);\r\n\r\n  /* Border Radius */\r\n  --radius-sm: 6px;\r\n  --radius-md: 10px;\r\n  --radius-lg: 16px;\r\n  --radius-xl: 24px;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: var(--font-main);\r\n  background: radial-gradient(circle at top right, #f9fafb, #f3f4f6);\r\n  color: var(--text-primary);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  line-height: 1.6;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n}\r\n\r\n/* Container Utility */\r\n.container {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 0 var(--spacing-md);\r\n}\r\n\r\n/* Grid Utility */\r\n.grid {\r\n  display: grid;\r\n  gap: var(--spacing-md);\r\n}\r\n\r\n.grid-cols-1 {\r\n  grid-template-columns: repeat(1, 1fr);\r\n}\r\n\r\n.grid-cols-2 {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.grid-cols-3 {\r\n  grid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.grid-cols-4 {\r\n  grid-template-columns: repeat(4, 1fr);\r\n}\r\n\r\n.grid-cols-5 {\r\n  grid-template-columns: repeat(5, 1fr);\r\n}\r\n\r\n/* Responsive Breakpoints */\r\n@media (min-width: 640px) {\r\n  .grid-sm-2 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .grid-md-2 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .grid-md-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .grid-lg-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  .grid-lg-4 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .grid-xl-5 {\r\n    grid-template-columns: repeat(5, 1fr);\r\n  }\r\n}\r\n/* Offer Sections */\r\n.offer-section {\r\n  margin-bottom: var(--spacing-xl);\r\n  width: 100%;\r\n}\r\n\r\n.offer-section-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: var(--spacing-sm);\r\n  padding: 0 var(--spacing-md);\r\n}\r\n\r\n.offer-section-title {\r\n  font-family: var(--font-title);\r\n  font-size: 28px;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  letter-spacing: -0.03em;\r\n}\r\n\r\n.offer-section-carousel-container {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.offer-section-grid {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  gap: var(--spacing-lg);\r\n  padding: 24px var(--spacing-md);\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.offer-section-grid::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.offer-section-grid > * {\r\n  flex: 0 0 280px;\r\n  min-width: 280px;\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .offer-section-carousel-container {\r\n     padding: 0 60px;\r\n  }\r\n\r\n  .offer-section-grid {\r\n    padding: 32px 0;\r\n  }\r\n\r\n  .offer-section-grid > * {\r\n    flex: 0 0 calc(20% - (var(--spacing-lg) * 4 / 5));\r\n    min-width: 200px;\r\n  }\r\n\r\n  .offer-section-header {\r\n    padding: 0 60px;\r\n  }\r\n}\r\n\r\n.carousel-arrow {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 50%;\r\n  background: var(--background-white);\r\n  border: 1px solid var(--border-color);\r\n  box-shadow: var(--shadow-md);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  z-index: 11;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  color: var(--text-primary);\r\n  visibility: hidden;\r\n  opacity: 0;\r\n}\r\n\r\n.offer-section-carousel-container:hover .carousel-arrow {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-arrow:hover {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  transform: translateY(-50%) scale(1.1);\r\n  box-shadow: var(--shadow-lg);\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.carousel-arrow-left {\r\n  left: 20px;\r\n}\r\n\r\n.carousel-arrow-right {\r\n  right: 20px;\r\n}\r\n\r\n.view-all-btn {\r\n  color: var(--primary-color);\r\n  background: var(--primary-light);\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  font-weight: 700;\r\n  font-family: var(--font-title);\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.view-all-btn:hover {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* View All Card in Carousel */\r\n.view-all-card:hover {\r\n  border-color: var(--primary-color) !important;\r\n  transform: translateY(-5px);\r\n  box-shadow: var(--shadow-md);\r\n  background-color: rgba(52, 131, 250, 0.02) !important;\r\n}\r\n\r\n.view-all-card:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .carousel-arrow {\r\n    display: none; /* Mobile usa scroll natural */\r\n  }\r\n  \r\n  .offer-section-carousel-container {\r\n    padding: 0;\r\n  }\r\n\r\n  .offer-section-header {\r\n    padding: 0 var(--spacing-md);\r\n  }\r\n}\r\n\r\n/* Breadcrumbs Section */\r\n.breadcrumb-container {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n}\r\n\r\n.breadcrumb-item {\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  padding: 2px 4px;\r\n  border-radius: 4px;\r\n  text-decoration: none;\r\n}\r\n\r\n.breadcrumb-item:hover {\r\n  color: var(--primary-color);\r\n  background-color: rgba(52, 131, 250, 0.1);\r\n}\r\n\r\n.breadcrumb-separator {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
